export const POLICY_BUILDER_AGENT_URL = 'https://ai-n8n.coverflex.com/webhook/public/chat/benefit_policy_builder_agent';
export const POLICY_BUILDER_AGENT_URL_ENTER = 'https://ai-n8n.coverflex.com/webhook/public/chat/benefit_policy_builder_agent_enter';
export const POLICY_BUILDER_DOWNLOAD_URL = 'https://ai-n8n.coverflex.com/webhook/public/chat/benefit_policy_builder_agent/download';
export const POLICY_BUILDER_JWT_SECRET = 'eyJhbGciOiJIUzI1NiJ9.e30.anvhSs9OypM9-bSKfFJwkduW2H9SInKgQoeQwq9Qq3Q';

// Generate UUID for conversation ID
export const generateConversationId = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

// Session management for conversation ID
export const getOrCreateConversationId = () => {
    const STORAGE_KEY = 'policy_builder_conversation_id';
    
    // Try to get existing conversation ID from sessionStorage
    let conversationId = sessionStorage.getItem(STORAGE_KEY);
    
    // If no conversation ID exists, create a new one
    if (!conversationId) {
        conversationId = generateConversationId();
        sessionStorage.setItem(STORAGE_KEY, conversationId);
        console.log('New conversation started with ID:', conversationId);
    } else {
        console.log('Continuing existing conversation with ID:', conversationId);
    }
    
    return conversationId;
};

// Clear conversation ID (for testing or new conversation)
export const clearConversationId = () => {
    const STORAGE_KEY = 'policy_builder_conversation_id';
    sessionStorage.removeItem(STORAGE_KEY);
    console.log('Conversation ID cleared');
};
